import styled from '@emotion/styled';
import { TextareaAutosize } from '@material-ui/core';

import InputLabel from 'uiToolkitV1/InputLabel';

import { useLocalState } from './useLocalState';

const StyledTextArea = styled(TextareaAutosize)`
  display: block;
  height: 40px;
  padding: 10px;
  padding-left: 0px;
  border-radius: 0px;
  border: none;
  border-bottom: 1px dashed ${(props) => props.theme.colors.text.g3};
  &:hover {
    border-bottom-style: solid;
    outline: unset;
  }
  &:focus, &:focus-within, &: active {
    border-bottom: 1px solid ${(props) => props.theme.colors.primary['1565BC']};
  }
  color: ${(props) => props.theme.colors.text.g1};
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  resize: none;
`;

const InputMaterialUITextArea = ({ ...textAreaProps }) => <StyledTextArea {...textAreaProps} />;

export const InitiativeDescriptionComp = ({ description, onChange }) => {
  const [localDescription, setLocalDescription] = useLocalState(description ?? '');

  const handleChange = (e) => setLocalDescription(e.target.value);

  const onBlur = (e) => {
    onChange(localDescription);
  };
  return (
    <InputMaterialUITextArea
      value={localDescription}
      onChange={handleChange}
      placeholder="Enter initiative description here..."
      onBlur={onBlur}
      width="100%"
      minRows={1}
      maxRows={5}
    />
  );
};

export const InitiativeDescription = ({ description, onChange }) => (
  <InputLabel labelText="Description">
    <InitiativeDescriptionComp description={description} onChange={onChange} />
  </InputLabel>
);
